import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {EnvService} from "../../services/env.service";
import {HttpClient} from "@angular/common/http";
import {ActivatedRoute, Router, Params} from '@angular/router';
import {AlertService} from "../../services/alert.service";
import {AuthService} from "../../services/auth.service";

@Component({
  selector: 'micro-accountTransaction-detail',
  templateUrl: './accountTransaction-detail.component.html'
})
export class AccountTransactionDetailComponent implements OnInit, OnChanges {
  accountTransaction:any;

  @Input()
  accountTransactionId:any;

  constructor(private env: EnvService,
              private http: HttpClient,
              private route: ActivatedRoute,
              private router:Router,
              public authService:AuthService,
              private alertService:AlertService) {
  }

  public ngOnInit(): void {
    if (!this.accountTransactionId) {
      this.route.params
        .subscribe((params: Params) => {
          let id: any = params['id'];
          this.accountTransactionId = id;
          this.reload();
        });
    } else {
      this.reload();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (let prop in changes) {
      if (prop === 'accountTransactionId') {
        this.reload();
      }
    }
  }

  setPaymentTransaction(accountTransaction:any) {
    this.accountTransaction = accountTransaction;
  }

  reload() {
    if (!this.accountTransactionId) {
      return;
    }
    this.http.get(`${this.env.e.url}/pay/accountTransactions/${this.accountTransactionId}`).subscribe(
      data => {
        this.setPaymentTransaction(data)
      }
    );
  }
}
